import PageAside from '../../components/pageaside/PageAside'
import Empty from '../empty/Empty'

import './video.css'

const Video = ({videos, isCurrent, isSetCurrent, isSetShow}) => {

      if(videos.data){
            return (
                  <div className={isCurrent === 'video' ? "page_content show" : "page_content"}>
                        <Empty text={`Texto here`}/>
                  </div>
            )
      }

      const onClose = () => {
            isSetShow(false)
            isSetCurrent('home')
      }

      return (
            <div className={isCurrent === 'video' ? "page_content show" : "page_content"}>
                  <div className="page_section">
                        <div className="video_content">
                              <h3>{videos[0].title}</h3>
                              <div className="video_box">
                                    <div className="video_box__iframe">
                                          <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videos[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <PageAside closePage={() => onClose()} title={`Video`} />
            </div>
      )
}

export default Video